"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("@/utils/index");
var _agendaLabels = require("@/utils/agendaLabels");
var _admin = require("@/store/modules/admin");
var _followUps = require("@/api/follow-ups");
var _admins = require("@/api/admins");
var _FollowUpTableData = _interopRequireDefault(require("./FollowUpTableData.vue"));
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.agendaLabels = _agendaLabels.agendaLabels;
    this.list = [];
    this.startDate = '';
    this.endDate = '';
    this.loggedInUser = null;
    this.radio = '1';
    this.adminsList = [];
    this.selectedAdminId = null;
    this.isPersonSelectVisible = false;
    this.missedCount = 0;
    this.upcomingCount = 0;
    this.ongoingCount = 0;
    this.tagType = {
      low: 'success',
      medium: 'warning',
      high: 'danger'
    };
    this.listQuery = {
      page: 1,
      limit: 10,
      assignedTo: _admin.AdminModule.id,
      dueDate: undefined,
      type: undefined,
      'lead.clientId': undefined,
      enabled: true,
      status: ['Completed'],
      isSuperAdminTask: false,
      sort: 'id,DESC',
      filter: {
        assignedTo: '$eq',
        enabled: '$eq',
        type: '$eq',
        dueDate: '$gte',
        'lead.clientId': '$eq',
        status: '$notin',
        isSuperAdminTask: '$eq'
      }
    };
  }
  created() {
    this.loggedInUser = _admin.AdminModule;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
    }
    this.getAdminList();
    if (!['Super Admin', 'System Admin', 'Admin'].includes(_admin.AdminModule.roles.toString())) {
      // add id to these fields
      this.listQuery.assignedTo = _admin.AdminModule.id;
    }
    this.handleChange();
    this.showPersonSelector();
  }
  async showPersonSelector() {
    const admin = await this.loggedInUser.GetAdminInfo();
    this.isPersonSelectVisible = ['Super Admin', 'System Admin', 'Admin'].includes(admin.role);
    return this.isPersonSelectVisible;
  }
  handleClick(tab, event) {
    if (tab.index === '1') {
      this.handleChange('Lost');
    } else if (tab.index === '2') {
      this.handleChange('upcoming');
    } else {
      this.handleChange();
    }
  }
  handleChange(status = null) {
    this.getCounts();
    this.listQuery.dueDate = new Date().toISOString();
    if (!status) {
      const date = new Date();
      date.setHours(23, 59, 59, 999);
      this.listQuery.dueDate = [new Date().toISOString(), date.toISOString()];
      this.listQuery.filter.dueDate = '$between';
    } else if (status === 'upcoming') {
      const date = new Date();
      date.setDate(date.getDate() + 1);
      date.setHours(0, 0, 0, 0);
      this.listQuery.dueDate = date.toISOString();
      this.listQuery.filter.dueDate = '$gte';
    } else {
      this.listQuery.filter.dueDate = '$lte';
    }
    this.fetchData();
  }
  async getCounts() {
    try {
      const adminId = this.selectedAdminId || _admin.AdminModule.id;
      const params = {
        adminId: adminId
      };
      const selectedAdmin = this.adminsList.find(admin => admin.id === adminId);
      if (['Super Admin', 'System Admin'].includes(selectedAdmin.adminsRole.name)) {
        params.isSuperAdminTask = true;
      }
      this.missedCount = +(await (0, _followUps.getFollowUpsMissedCount)(params));
      this.upcomingCount = +(await (0, _followUps.getFollowUpsUpcomingCount)(params));
      this.ongoingCount = +(await (0, _followUps.getFollowUpsOngoingCount)(params));
      // eslint-disable-next-line no-empty
    } catch (error) {}
  }
  handlePersonChange() {
    if (this.selectedAdminId) {
      this.listQuery.assignedTo = this.selectedAdminId;
      const selectedAdmin = this.adminsList.find(admin => admin.id === this.selectedAdminId);
      if (['Super Admin', 'System Admin'].includes(selectedAdmin.adminsRole.name)) {
        this.listQuery.isSuperAdminTask = true;
      } else {
        this.listQuery.isSuperAdminTask = false;
      }
    } else {
      this.listQuery.assignedTo = undefined;
    }
    this.fetchData();
    if (this.selectedAdminId) {
      this.getCounts();
    }
  }
  async fetchData() {
    const response = await (0, _followUps.getFollowUps)((0, _index.getQuery)(this.listQuery));
    this.list = response.data;
  }
  async getAdminList() {
    this.adminsList = await (0, _admins.getAdmins)((0, _index.getQuery)({
      enabled: true,
      sort: 'fullName,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ''
})], default_1.prototype, "dateRange", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'FollowUpTableData',
  components: {
    FollowUpTableData: _FollowUpTableData.default
  }
})], default_1);
var _default = exports.default = default_1;